module.exports = __webpack_public_path__ + "static/media/docker.7e6ccb94.svg";